// src/components/user/Mains.jsx
import React from "react";
import DailyMains from "./DailyMains";
import { motion } from "framer-motion";
import { PenTool, Target, Award } from "lucide-react";

const Mains = () => {
  const features = [
    {
      icon: <PenTool className="w-6 h-6 text-blue-500" />,
      title: "Daily Writing",
      desc: "Answer UPSC-style questions daily to sharpen your skills.",
    },
    {
      icon: <Target className="w-6 h-6 text-green-500" />,
      title: "Track Progress",
      desc: "Monitor your improvement and build consistency over time.",
    },
    {
      icon: <Award className="w-6 h-6 text-purple-500" />,
      title: "Model Answers",
      desc: "Compare with high-quality answers to refine your writing style.",
    },
  ];

  return (
    <div className="text-gray-800 space-y-8">
      {/* Header Section */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="mb-6"
      >
        <h1 className="text-3xl font-bold mb-2 flex items-center gap-2">
          📝 Mains Practice
        </h1>
        <p className="text-gray-600 text-lg">
          Build your answer writing habit with daily questions, structured
          feedback, and progress tracking.
        </p>
      </motion.div>

      {/* Feature Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {features.map((item, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.2 }}
            className="bg-white rounded-2xl shadow-md p-5 hover:shadow-lg transition duration-300"
          >
            <div className="flex items-center gap-3 mb-3">
              {item.icon}
              <h2 className="font-semibold text-lg">{item.title}</h2>
            </div>
            <p className="text-gray-600 text-sm">{item.desc}</p>
          </motion.div>
        ))}
      </div>

      {/* Daily Mains Component */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-6 shadow-inner"
      >
        <DailyMains />
      </motion.div>
    </div>
  );
};

export default Mains;
